Vue.component('daily-report', {
    props: {
        'selectedDay': {
            type: String
        },
        'baseUrl': {
            type: String
        }
    },

    data() {
        return {
            selectedDayMutable: this.selectedDay,
            filter: 'all'
        };
    },

    methods: {
        updatedate(val)
        {
            this.selectedDayMutable = val;
            this.filter = 'all';
        },

        getFilter(val)
        {
            this.filter = val;
        },
        
        widgetAjaxUrl(suffix)
        {
            const dt = moment(this.selectedDayMutable, "YYYY-MM-DD");
            return this.baseUrl+"/"+dt.format("YYYY/MM/DD")+(suffix ? "/"+suffix : "");
        }
    }
    
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/report/daily-report/daily-report.js